<template>
  <div class="of-content-3">
    <content3-card v-for="(card, i) in ofContent3.cards" :key="i" :view="card">
      <template v-for="(item, j) in card.content" slot="cardItem">
        <topper
          v-if="item.type == 'topper'"
          :key="i+'-'+j"
          :view="item"/>
        <item-right
          v-else-if="item.type == 'item-right'"
          :key="i+'-'+j"
          :view="item"
          :userTest="userTest"/>
        <item-left
          v-else-if="item.type == 'item-left'"
          :key="i+'-'+j"
          :view="item"
          :userTest="userTest"/>
        <item-left-larger
          v-else-if="item.type == 'item-left-larger'"
          :key="i+'-'+j"
          :view="item"
          :userTest="userTest"/>
        <item-right-larger
          v-else-if="item.type == 'item-right-larger'"
          :key="i+'-'+j"
          :view="item"
          :userTest="userTest"/>
      </template>
      <img
        slot="halfMoonUp"
        class="half-moon-up"
        slot-scope="upProps"
        :src='upProps.halfMoonUpPath'
        alt=""
        srcset=""
      >
      <img
        slot="halfMoonDown"
        class="half-moon-down"
        slot-scope="downProps"
        :src='downProps.halfMoonDownPath'
        alt=""
        srcset=""
      >
    </content3-card>
  </div>
</template>


<script>
  import itemRight from "./item-right.vue";
  import itemLeft from "./item-left.vue";
  import itemLeftLarger from "./item-left-larger.vue";
  import itemRightLarger from "./item-right-larger.vue";
  import topper from "./topper.vue";
  import content3Card from './card.vue'
  export default {
    name: "of-content-3",
    props: {
        view: {
            type: Object,
        },
        userTest: {
            type: Boolean,
        }
    },
    components: {
      "item-right": itemRight,
      "item-left": itemLeft,
      "item-left-larger": itemLeftLarger,
      "item-right-larger": itemRightLarger,
      "topper": topper,
      "content3-card": content3Card,
    },
    data() {
      return {
        cards: [
          { /* card1 */
            content: [
              { /* item1 */
                type: 'topper',
                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-mobile-topper.svg',
                title: 'Funnels',
                text: 'Aptent varius a velit dictum convallis cursus nam ullamcorper. Aliquet tellus per quisque. Feugiat nibh eleifend fusce inceptos nulla tellus quis sem.'
              },
              { /* item2 */
                type: 'item-right',
                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-premium-funnel.svg',
                title: {
                  text: 'Builderall Premium Funnels',
                  color: '#B07EFF' // color1
                },
                text: 'Affiliate funnels that are optimized for conversions. When you use the affiliate link for these funnels, they are designed to bring in new Builderall members with you as their sponsor. You can also brand the affiliate link with your own domain.',
                button: {
                  text: 'Learn more',
                  link: '#'
                },
                baIntelligenceTag: 'fc-c3-builderall-premium-funnels-us-id'
              },
              { /* item3 */
                type: 'item-right',
                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-niche-funnels.svg',
                title: {
                  text: 'Niche Funnels',
                  color: '#017AF7' // color2
                },
                text: 'Affiliate funnels designed to give to business owners so they can setup a free account with Builderall and start collecting their own leads.',
                button: {
                  text: 'Learn more',
                  link: '#'
                },
                baIntelligenceTag: 'fc-c3-niche-funnels-us-id'
              },
              { /* item4 */
                type: 'item-right',
                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-leads-capture-funnels.svg',
                title: {
                  text: 'Leads Capture Funnels',
                  color: '#002D92' // color3
                },
                text: 'Funnels designed to capture leads for your own subscriber list. These funnels are professionally designed for optin conversions and include the lead magnet in the funnel.',
                button: {
                  text: 'Learn more',
                  link: '#'
                },
                baIntelligenceTag: 'fc-c3-lead-capture-funnels-us-id'
              },
            ],
            halfMoonUpPath: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-half-moon.svg',
            halfMoonDownPath: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-half-moon.svg'
          },

          { /* card2 */
            content: [
              { /* item1 */
                type: 'item-left',
                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-agency-funnels.svg',
                title: {
                  text: 'Agency Funnels',
                  color: '#FFBE4B' // color4
                },
                text: 'Niche funnels templates in specific business areas that are designed for you to use as an website development agency to provide services to your own client.',
                button: {
                  text: 'Learn more',
                  link: '#'
                },
                baIntelligenceTag: 'fc-c3-agency-funnels-us-id'
              },
              { /* item2 */
                type: 'item-left',
                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-chatbot-funnels.svg',
                title: {
                  text: 'Chatbot Funnels',
                  color: '#470AC8' // color5
                },
                text: 'Meet Chat Marketing! Automate & Combine Facebook Messenger and SMS to Grow Your Business Sell products, book appointments, nurture leads, capture contact info, and build relationships all through the Builderall Messenger Chatbot.',
                button: {
                  text: 'Learn more',
                  link: '#'
                },
                baIntelligenceTag: 'fc-c3-chatbot-funnels-us-id'
              },
              { /* item3 */
                type: 'item-left',
                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-info-product-funnels.svg',
                title: {
                  text: 'Info Product Funnels',
                  color: '#00e1d6' // color7
                },
                text: 'Info Product Funnels',
                button: {
                  text: 'Learn more',
                  link: '#'
                },
                baIntelligenceTag: 'fc-c3-info-product-funnels-us-id'
              },
            ],
            halfMoonUpPath: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-half-moon.svg',
            halfMoonDownPath: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-half-moon.svg'
          },
          { /* card3 */
            content: [
              { /* item4 */
                type: 'item-right',
                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-physical-product-funnels.svg',
                title: {
                  text: 'Physical Product Funnels',
                  color: '#03e18e' // color8
                },
                text: 'Physical Product Funnels',
                button: {
                  text: 'Learn more',
                  link: '#'
                },
                baIntelligenceTag: 'fc-c3-physical-product-funnels-us-id'
              },
              { /* item5 */
                type: 'item-right',
                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-market-place-funnel.svg',
                newIcon: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-market-place-funnel.svg',
                title: {
                  text: 'Marketplace Funnels',
                  color: '#3384fb' // color9
                },
                text: 'Marketplace Funnels',
                button: {
                  text: 'Learn more',
                  link: '#'
                },
                baIntelligenceTag: 'fc-c3-marketplace-funnels-us-id'
              },
              { /* item6 */
                type: 'item-left-larger',
                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-cheetah-funnel-builder.svg',
                title: {
                  text: 'Cheetah Funnel Builder',
                  color: '#FF7166' // color6
                },
                text: 'Where all the magic happens when all of our fully integrated tools come together to give you the power to build impressive funnel blueprints and then, with a push of the button, create the entire site directly from the blueprint.',
                button: {
                  text: 'Learn more',
                  link: '#'
                },
                baIntelligenceTag: 'fc-c3-cheetah-funnel-builder-us-id'
              },
            ],
            halfMoonUpPath: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-half-moon.svg',
            halfMoonDownPath: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-half-moon.svg'
          },
        ]
      }
    },
    computed: {
      ofContent3: function () {
          return (this.view !== undefined && this.view !== null) ? this.view : this.$data
      }
    },
    created() {},
    mounted() {},

  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../../../../scss/office";

  .of-content-3 {
    font: inherit;

    margin-bottom: 2.4em!important; /* 24px */

    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    row-gap: 2.4em; /*24px*/
    justify-items: stretch;
    align-items: stretch;
    justify-content: stretch;
    align-content: stretch;
  }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-3/index.vue